import { Languages } from "../../config/languages";

export const URLEncode = (str: string): string => str.split(' ').join('-').toLowerCase();

export const isHome = (url: string, language: Languages): boolean => {
  return url === `/${language}` || url === `/${language}/`;
};
